import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';
import { Editor } from "react-draft-wysiwyg";
import { convertToHTML } from 'draft-convert';
import { EditorState, ContentState, convertFromHTML } from 'draft-js';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ToggleOffIcon from '@mui/icons-material/ToggleOff';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { addScheduleEducation, getScheduleEducations, toggleScheduleEducation, updateScheduleEducation } from '../../utilities/sendRequest';
import { statusOptions } from '../../utilities/selectOptions';
import { createSlug, dateDDMMYYY } from '../../utilities/helper';

const CardSchedule = ({ educationId, fetchAgain, setFetchAgain }) => {
    const [isReady, setIsReady] = useState(false)
    const [fetchMore, setFetchMore] = useState(false)
    const [isUpdate, setIsUpdate] = useState(false)
    const [data, setData] = useState([])

    const [title, setTitle] = useState("")
    const [link, setLink] = useState("")
    const [status, setStatus] = useState("")
    const [scheduleDate, setScheduleDate] = useState("")
    const [scheduleTime, setScheduleTime] = useState("")
    const [editorState, setEditorState] = useState(
        () => EditorState.createEmpty(),
    );
    
    const [convertedContent, setConvertedContent] = useState(null);
    const [datas, setDatas] = useState([])

    useEffect(() => {
        fetchSchedule();
        setFetchMore(false);
        setFetchAgain(false);
        
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fetchMore, fetchAgain])

    useEffect(() => {
        const isReady = (link !== "" && title !== "" && scheduleDate !== "" && scheduleTime !== "");
        setIsReady(isReady);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [link, title, scheduleDate, scheduleTime])

    useEffect(() => {
        let html = convertToHTML(editorState.getCurrentContent());
        setConvertedContent(html);
    
    }, [editorState]);

    const fetchSchedule = async () => {
        getScheduleEducations(educationId).then((res) => {
            setDatas(
                res.payload.sort((p1, p2) => {
                    return new Date(p2.createdAt) - new Date(p1.createdAt)
                })
            )
        }).catch((err) => {
            toast.error(err, {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 3000
            });
        })  
    }

    const columns = [
        {
            field: 'title',
            headerName: 'Title',
            width: 200,
            renderCell: (params) => {
                return (
                    <div className="font-ssp">
                        {params.row.title}
                    </div>
                )
            } 
        },
        {
            field: 'publish_time',
            headerName: 'Schedule',
            width: 200,
            renderCell: (params) => {
                return (
                    <div className="font-ssp">
                        {dateDDMMYYY(params.row.publish_date)} - {params.row.publish_time}
                    </div>
                )
            } 
        },
        // {
        //     field: 'link',
        //     headerName: 'Meeting',
        //     width: 200,
        //     renderCell: (params) => {
        //         return (
        //             <div className="font-ssp">
        //                 {params.row.link}
        //             </div>
        //         )
        //     } 
        // },
        { 
            field: 'is_active', 
            headerName: 'Status',
            width: 100, 
            renderCell: (params) => {
                return (
                    <div className='flex justify-center items-center font-ssp'>
                        {params.row.is_active
                            ? <span className="px-2 py-1 bg-green-400 rounded-full text-white uppercase">active</span>
                            : <span className="px-2 py-1 bg-red-400 rounded-full text-white uppercase">inactive</span>
                        }
                    </div>
                )
            } 
        },
        {
            field: 'action',
            headerName: 'Action',
            width: 150,
            renderCell: (params) => {
                return (
                    <div className='w-full flex flex-row gap-3 items-center'>
                        <VisibilityIcon onClick={() => handleDetail(params.row)} fontSize='medium' className="text-slate-400 hover:text-slate-500 cursor-pointer"/>
                        {params.row.is_active
                            ? <ToggleOnIcon className="text-green-400 hover:text-green-500 cursor-pointer" onClick={() => handleToggle(params.row.slug)}/>
                            : <ToggleOffIcon className="text-gray-400 hover:text-gray-500 cursor-pointer" onClick={() => handleToggle(params.row.slug)}/>
                        }
                    </div>
                )
            }
        },
    ]

    const handleDetail = (tempData) => {
        setData(tempData);
        setTitle(tempData.title)
        setLink(tempData.link)
        setScheduleDate(tempData.publish_date)
        setScheduleTime(tempData.publish_time)
        setStatus(tempData.is_active)
        setEditorState(EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(tempData.description))))
        setIsUpdate(true)
    }

    const handleReset = () => {
        setData([])
        setTitle("")
        setLink("")
        setStatus("")
        setScheduleDate("")
        setScheduleTime("")
        setEditorState(() => EditorState.createEmpty())
        setIsUpdate(false)
    }

    const handleToggle = (paramsSlug) => {
        toggleScheduleEducation(paramsSlug).then((res) => {
            toast.success(res.message, {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 3000
            });
            setFetchMore(true)
        }).catch((error) => {
            toast.error(error.response.data.message, {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 3000
            });
        })
    }

    const handleUpdate = async (e) => {
        e.preventDefault()
    
        setIsReady(false);
        const slug = createSlug(title)
    
        const reqData = {
            title,
            slug,
            description: convertedContent,
            is_active: status,
            link,
            publish_date: scheduleDate,
            publish_time: scheduleTime,
            education_id: data.education_id
        }
    
        updateScheduleEducation(data.slug, reqData).then((res) => {
            toast.success(res.message, {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 3000
            });
            setFetchMore(true)
        }).catch((err) => {
            toast.error(err.response.data.message, {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 3000
            });
        }).finally(() => {
            setIsReady(true);
            handleReset();
        })
    }

    const handleCreate = async (e) => {
        e.preventDefault()
    
        setIsReady(false);
        const slug = createSlug(title)
    
        const reqData = {
            title,
            slug,
            description: convertedContent,
            is_active: status,
            link,
            publish_date: scheduleDate,
            publish_time: scheduleTime,
            education_id: educationId
        }
    
        addScheduleEducation(reqData).then((res) => {
            toast.success(res.message, {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 3000
            });
            setFetchMore(true)
        }).catch((err) => {
            toast.error(err.response.data.message, {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 3000
            });
        }).finally(() => {
            setIsReady(true);
            handleReset();
        })
    }

    return (
        <div className={`my-5 flex flex-col lg:flex-row justify-start gap-7 md:gap-10`}>
            {/* list data */}
            <div className='w-full h-full lg:w-[60%] flex flex-col gap-3 items-center'>
                <div className="p-2 w-full flex bg-white drop-shadow-lg rounded-md">
                    <DataGrid
                        autoHeight {...datas}
                        rows={datas}
                        columns={columns}
                        pageSize={5}
                        getRowId={(row) => row.id}
                        rowsPerPageOptions={[5]}
                        checkboxSelection
                        disableSelectionOnClick
                        components={{ Toolbar: GridToolbar, }}
                    />
                </div>
            </div>

            <div className="px-2 py-4 w-full h-fit lg:w-[40%] bg-white drop-shadow-lg rounded-md flex flex-col gap-3">
                <h1 className='font-semibold text-base font-ssp px-3'>{isUpdate ? "Update" : "Add"} Schedule</h1>
                <hr className='px-3'/>
                <div className=" py-1 w-full h-fit flex">
                    <form onSubmit={isUpdate ? handleUpdate : handleCreate} className='px-5 w-full flex flex-col justify-between'>
                        {/* title */}
                        <div className="mt-3 mb-6 w-full relative z-0 group">
                            <input 
                                minLength={5} 
                                value={title} 
                                onChange={(e) => setTitle(e.target.value)} 
                                type="text" 
                                name="title" 
                                id="title" 
                                className="block py-2.5 px-2 w-full text-sm text-gray-900 bg-transparent 
                                            border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 
                                            focus:border-blue-600 peer" 
                                placeholder=" " 
                                required 
                            />
                            <label 
                                htmlFor="title" 
                                className="absolute top-3 -z-10 text-sm text-gray-500 
                                            duration-300 transform -translate-y-6 scale-75 origin-[0] peer-focus:left-0 peer-focus:font-medium 
                                            peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 
                                            peer-focus:scale-75 peer-focus:-translate-y-6"
                            >Title</label>
                        </div>
                        {/* date */}
                        <div className="mt-3 mb-6 w-full relative z-0 group">
                            <input 
                                value={scheduleDate} 
                                onChange={(e) => setScheduleDate(e.target.value)} 
                                type="date" 
                                name="scheduleDate" 
                                id="scheduleDate" 
                                className="block py-2.5 px-2 w-full text-sm text-gray-900 bg-transparent 
                                            border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 
                                            focus:border-blue-600 peer" 
                                placeholder=" " 
                                required 
                            />
                            <label 
                                htmlFor="scheduleDate" 
                                className="absolute top-3 -z-10 text-sm text-gray-500 
                                            duration-300 transform -translate-y-6 scale-75 origin-[0] peer-focus:left-0 peer-focus:font-medium 
                                            peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 
                                            peer-focus:scale-75 peer-focus:-translate-y-6"
                            >Schedule Date</label>
                        </div>
                        {/* time */}
                        <div className="mt-3 mb-6 w-full relative z-0 group">
                            <input 
                                value={scheduleTime} 
                                onChange={(e) => setScheduleTime(e.target.value)} 
                                type="time" 
                                name="scheduleTime" 
                                id="scheduleTime" 
                                className="block py-2.5 px-2 w-full text-sm text-gray-900 bg-transparent 
                                            border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 
                                            focus:border-blue-600 peer" 
                                placeholder=" " 
                                required 
                            />
                            <label 
                                htmlFor="scheduleTime" 
                                className="absolute top-3 -z-10 text-sm text-gray-500 
                                            duration-300 transform -translate-y-6 scale-75 origin-[0] peer-focus:left-0 peer-focus:font-medium 
                                            peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 
                                            peer-focus:scale-75 peer-focus:-translate-y-6"
                            >Schedule Time</label>
                        </div>
                        {/* Link */}
                        <div className="mt-3 mb-6 w-full relative z-0 group">
                            <input 
                                minLength={5} 
                                value={link} 
                                onChange={(e) => setLink(e.target.value)} 
                                type="text" 
                                name="link" 
                                id="link" 
                                className="block py-2.5 px-2 w-full text-sm text-gray-900 bg-transparent 
                                            border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 
                                            focus:border-blue-600 peer" 
                                placeholder=" " 
                                required 
                            />
                            <label 
                                htmlFor="link" 
                                className="absolute top-3 -z-10 text-sm text-gray-500 
                                            duration-300 transform -translate-y-6 scale-75 origin-[0] peer-focus:left-0 peer-focus:font-medium 
                                            peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 
                                            peer-focus:scale-75 peer-focus:-translate-y-6"
                            >Link</label>
                        </div>
                        {/* description */}
                        <div className="mt-3 mb-6 w-full relative z-0 group">
                            <label 
                                htmlFor="description" 
                                className="text-sm text-gray-500 duration-300 transform -translate-y-6 
                                            scale-75 origin-[0] peer-focus:left-0 peer-focus:text-blue-600 peer-focus:font-medium 
                                            peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                            >Description</label>
                            <Editor
                                editorState={editorState}
                                onEditorStateChange={setEditorState}
                                wrapperClassName="mt-2 border h-[500px] md:h-[300px] relative flex flex-col overflow-hidden border border-gray-300"
                                toolbarClassName="sticky"
                                editorClassName="px-2 overflow-y-scroll"
                            />
                        </div>
                        {/* status */}
                        <div className="mt-3 mb-6 w-full relative z-0 group">
                            <select 
                                required 
                                value={status} 
                                onChange={(e) => setStatus(e.target.value)} 
                                id="status" 
                                className="block py-2.5 px-2 w-full text-sm text-gray-500 bg-transparent 
                                            border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 
                                            focus:border-blue-600 peer"
                            >
                                {statusOptions.map((option) => (
                                    <option key={option.value} value={option.value}>{option.label}</option>
                                ))}
                            </select>
                            <label 
                                htmlFor="status" 
                                className="absolute top-3 -z-10 text-sm text-gray-500 
                                            duration-300 transform -translate-y-6 scale-75 origin-[0] peer-focus:left-0 peer-focus:font-medium 
                                            peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 
                                            peer-focus:scale-75 peer-focus:-translate-y-6"
                            >Status</label>
                        </div>
                        {/* button */}
                        <div className="mb-6 w-full relative z-0 flex justify-center gap-5">
                            <button 
                                type="submit" 
                                disabled={!isReady}
                                className={`mt-5 px-5 py-2.5 w-fit rounded-lg sm:w-autorounded-lg font-medium text-sm text-center ${isReady ? 'text-white bg-green-400 hover:bg-green-500 cursor-pointer' : 'text-gray-800 bg-gray-300 cursor-wait'}`}
                            >Submit</button>
                            <div 
                                onClick={handleReset}
                                className={`mt-5 px-5 py-2.5 w-fit rounded-lg sm:w-autorounded-lg font-medium text-sm text-center text-white bg-red-400 hover:bg-red-500 cursor-pointer`}
                            >Reset</div>
                        </div>
                    </form>                    
                </div>
            </div>
        </div>
    )
}

CardSchedule.propTypes = {
    educationId: PropTypes.number,
    fetchAgain: PropTypes.bool,
    setFetchAgain: PropTypes.func,
}

export default CardSchedule